import b64toBlob from "./b64toBlob";
import generateId from "./generateId";

class GetImagesFromAtlasPhaser extends Phaser.Scene {
    name_spritesheet = '';
    constructor() {
        super({key: 'GetImagesFromAtlasPhaser'});
    }
    preload() {
        const output: any = [];
        let parent_id = '';
        this.registry.events.on('CHARGE_ATLAS', (image_config: any) => {
            parent_id = image_config.image.id;
            this.name_spritesheet = image_config.image.name;
            this.load.atlas(this.name_spritesheet, URL.createObjectURL(b64toBlob(image_config.image.src)), JSON.parse(image_config.json));
            this.load.start();
        });

        this.load.on(Phaser.Loader.Events.COMPLETE, () => {
            const texturesKeys = Object.keys(this.textures.get(this.name_spritesheet).frames);
            for (let i = 1; i < texturesKeys.length; i++) {
                let name = texturesKeys[i];
                
                const texture = this.textures.getFrame(this.name_spritesheet, name);
                const textureB64 = this.textures.getBase64(this.name_spritesheet, name);
                output.push({
                    parent_id,
                    id: generateId(),
                    name,
                    width: texture.width,
                    height: texture.height,
                    src: textureB64,
                    origin: { x: 0.5, y: 0.5 }
                });
            }
            this.registry.events.emit('ATLAS_COMPLETE', output);
        });
    }
}

/**
 * Esta función nos ayudará a obtener un array de imágenes a partir de un atlas
 * @returns Promise(atlas_group)
 */
const getImagesFromAtlas = (image_config: any) => {
    const divElement = document.createElement('div');
    divElement.setAttribute('id', 'container_phase_spritesheet');
    divElement.setAttribute('style', 'position: absolute;top: -2000px;visibility: hidden');
    document.body.appendChild(divElement);
    const game = new Phaser.Game({
        width: 100,
        height: 100,
        type: Phaser.CANVAS,
        banner: {
            hidePhaser: true
        },
        parent: 'container_phase_spritesheet',
        backgroundColor: 'rgba(0,0,0,0)',
        render: {
            pixelArt: true
        },
        scene: [GetImagesFromAtlasPhaser]
    });

    game.events.on(Phaser.Scenes.Events.READY, () => {
        game.registry.events.emit('CHARGE_ATLAS', image_config);
    });

    return new Promise((resolve) => {
        game.events.on('ATLAS_COMPLETE', (atlas_group: any) => {
            game.destroy(true);
            document.body.removeChild(divElement);
            resolve(atlas_group);
        });
    });
}


export default getImagesFromAtlas;